module.exports = __webpack_public_path__ + "img/white-lalak-logo.128646b2.png";